import { ADDRESSES, type Address } from "../data/types";
import { t } from "../utils/i18n";

interface Props {
  value: Address;
  onChange: (a: Address) => void;
}

export function AddressSelector({ value, onChange }: Props) {
  return (
    <div className="w-full">
      <h3 className="mb-1.5 text-center text-xs font-semibold uppercase tracking-wide text-slate-600">
        {t("serverAddress")}
      </h3>
      <div className="flex flex-col gap-1.5">
        {ADDRESSES.map((a) => {
          const active = a === value;
          return (
            <button
              key={a}
              onClick={() => onChange(a)}
              className={
                "flex h-10 w-full items-center justify-center rounded border text-sm font-semibold transition-colors " +
                (active
                  ? "border-sky-600 bg-sky-600 text-white"
                  : "border-slate-300 bg-white text-slate-700 hover:bg-slate-50")
              }
            >
              {a}
            </button>
          );
        })}
      </div>
    </div>
  );
}
